import React, { Component } from "react";
import AddIcon from "@material-ui/icons/Add";
import Button from "@material-ui/core/Button";
export class PtsButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      onClick: props.onClick,
      caption: props.caption,
      type: props.type,
    };
  }

  onClick() {
    if (this.state.onClick) {
      this.state.onClick();
    }
  }
  render() {
    return (
      <Button
        id="ptsHollowButton"
        type="submit"
        variant="contained"
        // size="small"
        // style={{
        //   textTransform: "capitalize",
        //   padding: "2px 10px",
        //   // background: "#6A7B8E",
        //   background: "#d3d8de",
        //   color: "#fff",
        //   borderColor: "#d3d8de",
        //   // fontWeight: "bold",
        // }}
        // className="btn btn-default "
        onClick={this.onClick.bind(this)}
        startIcon={<AddIcon style={{ fontWeight: "600" }} />}
      >
        {this.props.btnName}
      </Button>
    );
  }
}
export default PtsButton;
